<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <form v-on:submit.prevent="submitForm">
      <v-row>
        <v-col cols="8">
          <v-row>
            <v-col cols="6">
              <v-card dark :loading="loading">
                <v-card-title>
                  Patient Info
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>Patient ID</td>
                        <td>:</td>
                        <td class="">{{ patient_info.patient_id }}</td>
                      </tr>
                      <tr>
                        <td>Name</td>
                        <td>:</td>
                        <td class="">{{ patient_info.patient_name }}</td>
                      </tr>
                      <tr>
                        <td>Age</td>
                        <td>:</td>
                        <td class="">{{ patient_info.patient_age }}</td>
                      </tr>
                      <tr>
                        <td>Phone</td>
                        <td>:</td>
                        <td class="">{{ patient_info.patient_phone }}</td>
                      </tr>
                      <tr>
                        <td>Created at</td>
                        <td>:</td>
                        <td class="">{{ patient_info.create_date }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card dark :loading="loading">
                <v-card-title>
                  Surgery Info
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>Registration ID</td>
                        <td>:</td>
                        <td class="">{{ op_registration.registration_no }}</td>
                      </tr>
                      <tr>
                        <td>Surgery Name</td>
                        <td>:</td>
                        <td class="">{{ operation.name }}</td>
                      </tr>
                      <tr>
                        <td>Eye Type</td>
                        <td>:</td>
                        <td class="">{{ op_registration.eye_type }}</td>
                      </tr>
                      <tr>
                        <td>Operation Type</td>
                        <td>:</td>
                        <td class="">{{ operation.op_type }}</td>
                      </tr>
                      <tr>
                        <td>Doctor</td>
                        <td>:</td>
                        <td class="">{{ doctor.dr_name }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>

          <v-card>
            <v-card-title>
              OT Bill: Receive
              <v-spacer></v-spacer>
            </v-card-title>
            <v-col cols="12">
              <v-text-field
                v-model="receive_amount"
                label="Receive Amount"
                outlined
                clearable
              ></v-text-field>
              
                <v-select
                v-model="payment_method"
                  item-text="name"
                  :items="paymentMethods"
                  label="Payment Method"
                  solo
                ></v-select>
             
              <div class="text-right">
                <v-btn small color="primary" type="submit">Submit</v-btn>
              </div>
            </v-col>
          </v-card>
        </v-col>

        <v-col cols="4">
          <v-card :loading="loading">
            <v-card-title>
              Invoice Details
              <v-spacer></v-spacer>
            </v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Invoice ID</th>
                    <th class="text-left">Paid Amount</th>
                    <th class="text-left">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in invoices" :key="item.invoice_id">
                    <td>{{ item.invoice_id }}</td>
                    <td class="text-right">{{ item.paid_amount }}</td>
                    <td>{{ item.create_date }}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <th class="text-right">{{ invoice_total | currency }}</th>
                    <td></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <v-spacer></v-spacer>
        </v-col>
      </v-row>
    </form>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
import "vuejs-noty/dist/vuejs-noty.css";

export default {
  data() {
    return {
      patient_info: { patient_name: null },
      doctor: { patient_name: null },
      operation: { patient_name: null },
      op_registration: { patient_name: null },
      patient_reg_no: this.$route.params.id,
      sureonList: [],
      receive_amount: 0,
      refund_note: "",
      loading: true,
      paymentMethods: ["Cash", "Bkash", "Card"],
      payment_method:'',
      user_id: localStorage.getItem("userId"),
      headers: [
        {
          text: "Invoice ID",
          align: "start",
          value: "invoice_id",
        },
        { text: "Amoount", value: "paid_amount" },
        { text: "Date", value: "create_date" },
      ],
      invoices: [],
      errors: [],
      invoice_total: 0,
      ledgerHead: [],
      rules: [
        (value) => !!value || "Required.",
        (value) => (value && value.length >= 1) || "Min 3 characters",
      ],
      numberRule: (val) => {
        if (val < 0) return "Please enter a positive number";
        return true;
      },
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Bill Receive",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
    atshq
      .get("/payment-methods")
      .then((response) => {
        this.paymentMethods = response.data.data;
      })
      .catch((e) => {
        this.errors = true;
        this.errorMessage = e;
      });
  },
  methods: {
    initialize() {
      // alert(this.patient_reg_no);
      atshq
        .get("ot-bill/create?reg_id=" + this.patient_reg_no)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.patient_info = response.data.data.patient;
          this.invoices = response.data.data.invoice_list;
          this.doctor = response.data.data.doctor;
          this.operation = response.data.data.operation_details;

          this.op_registration = response.data.data.op_registration;
          this.sureonList = response.data.data.doctorlist;
          this.loading = false;
          this.invoice_total = this.invoices.reduce(
            (acc, item) => acc + parseInt(item.paid_amount),
            0
          );
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    submitForm() {
      if (confirm("are you sure?"))
        atshq
          .post("ot-bill-receive", {
            formdata: this.form,
            receive_amount: this.receive_amount,
            refund_note: this.refund_note,
            op_reg_id: this.patient_reg_no,
            payment_method:this.payment_method,
            user_id: this.user_id,
          })
          .then((res) => {
            //Perform Success Action
            if (res.status == "200") {
              this.$noty.success(res.data.messages);
              //   window.open("otbill-refund/" + res.data.data.op_reg_id);
              window.location.href =
                this.returnUrl +
                "printdoc/invoice/" +
                res.data.invoice_id+'/1';
              // this.$router.go(this.$router.currentRoute);
              //   alert('Successfuly create this ot bill');
            }
          })
          .catch((e) => {
            // error.response.status Check status code
            // console.log(e);
            // this.$noty.show(e.error);
            this.$noty.error("Oops, something went wrong!");

            this.errors.push(e);
          })
          .finally(() => {
            //Perform action in always
          });
    },
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    },
  },
};
</script>